import { render } from "./SendQuoteDialog.vue?vue&type=template&id=244e52cf&scoped=true"
import script from "./SendQuoteDialog.vue?vue&type=script&lang=js"
export * from "./SendQuoteDialog.vue?vue&type=script&lang=js"

import "./SendQuoteDialog.vue?vue&type=style&index=0&id=244e52cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-244e52cf"]])

export default __exports__